<template>
  <div class="app-container">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox">
        <div class="detailsTitle">
          <h4>账单详情</h4>
          <div @click="back"><i class="fa fa-reply"></i></div>
        </div>
        <!-- 查询条件 -->
        <div class="formBox margbot">
          <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini" style="width: 100%;">
            <el-form-item label="运单号:"    class="item1">
                <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNos" ></el-input>
            </el-form-item>
            <el-form-item label="开票状态:"  >
                <el-select v-model="searchFrom.ysInvoicingStates" placeholder="请选择开票状态">
                  <el-option v-for="item in ysInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            <div style="">
              <el-form-item>
                <el-button type="primary" size="mini" @click="getList">查询</el-button>
                <el-button type="primary" size="mini" @click="chongZhi1">重置</el-button>
                <el-button type="primary" size="mini" @click="addYSFn" v-if="btnFlg[2]">添加应收</el-button>
                <el-button type="primary" size="mini" @click="delFn" v-if="btnFlg[3]">删除</el-button>
                <!-- <el-button type="primary" size="mini" @click="buFenKPFn" v-if="btnFlg[4]">部分开票</el-button> -->
                <el-button type="primary" size="mini" @click="buFenSKFn" v-if="btnFlg[5]">部分收款</el-button>
                <el-button type="primary" size="mini" @click="SQkaiPiaoFn" v-if="btnFlg[1]">申请开票</el-button>
                <el-button type="primary" size="mini" @click="shouKuanFn" v-if="btnFlg[0]">收款</el-button>
              </el-form-item>
              <el-form-item>
                <div style="display:flex;">
                  <p style="width:15px;height:15px;background:#f9bc04;margin-top: 6px;"></p>
                  <span style="margin-left:5px;">超期未结算</span>
                </div>
              </el-form-item>
              <span>
                <el-form-item>
                  <p class="margin0">已选未收款金额：<span class="red">{{shouKuanFrom.pendingAmount}}</span>元</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">已选未开票金额：<span class="red">{{kaiPiaoFrom.invoiceAmount}}</span>元</p>
                </el-form-item>
              </span>
            </div>
          </el-form>
        </div>
      </div>
      <!--表格1-->
      <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
        <el-table :data="tableList" ref="tableList" class="tableComent" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
        :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change='selectGoods'
        :row-class-name="tableRowClassName">
          <el-table-column type="selection" width="50" fixed></el-table-column>
          <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
          <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
          <el-table-column prop="" label="结算状态" width="120">
            <template scope="scope">
              <span class="wsStyle" v-show="scope.row.ysSettlementStates == '-1'">未对账</span>
              <span class="wsStyle" v-show="scope.row.ysSettlementStates == '0'">未收款</span>
              <span class="bfStyle" v-show="scope.row.ysSettlementStates == '1'">部分收款</span>
              <span class="ysStyle" v-show="scope.row.ysSettlementStates == '2'">已收款</span>
              <span class="ysStyle" v-show="scope.row.ysSettlementStates == '3'">不收款</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="开票状态" width="120">
            <template scope="scope">
              <!-- 0.未开票、1.部分开票、2.已开票 -->
              <span class="wsStyle" v-show="scope.row.ysInvoicingStates == '0'">待申请</span>
              <span class="bfStyle" v-show="scope.row.ysInvoicingStates == '11'">待开票</span>
              <span class="bfStyle" v-show="scope.row.ysInvoicingStates == '1'">部分开票</span>
              <span class="ysStyle" v-show="scope.row.ysInvoicingStates == '2'">已开票</span>
               <span class="ysStyle" v-show="scope.row.ysInvoicingStates == '3'">不开票</span>
            </template>
          </el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" width="120">
          </el-table-column>
          <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="revenueValuationName" label="收入计价" width="120" :formatter="formatterRowEmpty">
            <!-- <template scope="scope">
              0.按吨、1.按车、2.按方、3.按件
              <span v-show="scope.row.revenueValuation == '0'">按吨</span>
              <span v-show="scope.row.revenueValuation == '1'">按车</span>
              <span v-show="scope.row.revenueValuation == '2'">按方</span>
              <span v-show="scope.row.revenueValuation == '3'">按件</span>
            </template> -->
          </el-table-column>
          <el-table-column prop="" label="收入单价" width="120">
            <template scope="scope">
              <div>
                <span v-if="scope.row.revenueValuation == '0'">{{scope.row.incomeUnitPrice}}元/吨</span>
                <span v-if="scope.row.revenueValuation == '1'">
                  <span v-if="scope.row.incomeUnitPrice != 0">{{scope.row.incomeUnitPrice}}元/车</span>
                  <span v-else>-</span>
                </span>
                <span v-if="scope.row.revenueValuation == '2'">{{scope.row.incomeUnitPrice}}元/方</span>
                <span v-if="scope.row.revenueValuation == '3'">{{scope.row.incomeUnitPrice}}元/件</span>
                <span v-if="scope.row.revenueValuation == '' || scope.row.revenueValuation == null">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="incomeAmount" label="收入金额(元)" width="130">
          </el-table-column>
          <el-table-column prop="revenueSurcharge" label="收入附加费(元)" width="130">
          </el-table-column>
          <el-table-column prop="grossRevenue" label="收入总额(元)" width="130">
          </el-table-column>
          <el-table-column prop="ysPaymentAmount" label="已收款金额(元)" width="130">
          </el-table-column>
          <el-table-column prop="ysNoPaymentAmount" label="未收款金额(元)" width="130">
          </el-table-column>
          <el-table-column prop="ysInvoiceAmount" label="已开票金额(元)" width="130">
          </el-table-column>
          <el-table-column prop="ysNoInvoiceAmount" label="未开票金额(元)" width="130">
          </el-table-column>
          <el-table-column prop="plateNumber" label="车牌号" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverPhone" label="司机电话" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="projectType" label="项目名称" width="160"> </el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="makeTicketYn" label="是否开票" width="120">
          </el-table-column>
          <el-table-column prop="ysInvoiceOn" label="发票号" width="200" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <!-- <div class="pags" style="text-align: left;">
        <el-pagination
          background
          @current-change="handleCurrentChangeA"
          :current-page="current"
          :page-size="pagesize"
          :page-sizes="[10, 20, 30, 40,50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChangeA"
          :total="total"
        ></el-pagination>
      </div> -->
    </div>
    <!-- 添加应收 -->
    <div>
      <el-dialog :title="YSTitle" :visible.sync="YSAddMark" :close-on-click-modal="false" width="80%" center @close="closeDialog"
      >
        <div >
          <div>
            <el-form :inline="true" :model="YSAddFrom" class="demo-form-inline" size="mini" label-width="100px">
              <!-- <el-form-item label="创建时间:">
                <el-date-picker
                  v-model="createTimes"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item> -->
              <el-form-item label="签收时间:">
                <el-date-picker
                  v-model="actualSignings"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="车牌号:">
                <el-input v-model="YSAddFrom.plateNumber" size="mini" placeholder="请输入车牌号"></el-input>
              </el-form-item>
              <el-form-item label="收货地址:">
                <el-input v-model="YSAddFrom.receivingAddress" size="mini" placeholder="请输入车牌号"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
                <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div>
            <el-table :data="listYSData" ref="listYSData" class="elTab" highlight-current-row border size="mini" style="width:100%"
            :header-cell-style="{background:'#F5F5F5',color:'black'}"
            >
              <el-table-column type="selection" width="50" fixed></el-table-column>
              <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
              <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
              <el-table-column prop="incomePatternName" label="收入方式" width="90" :formatter="formatterRowEmpty">
                <!-- <template scope="scope">
                  <span v-show="scope.row.incomePattern == '0'">月结</span>
                  <span v-show="scope.row.incomePattern == '1'">现结</span>
                </template> -->
              </el-table-column>
              <el-table-column prop="makeTicketYn" label="是否开票" width="90">
              </el-table-column>
              <el-table-column prop="productTypeName" label="货物类型" width="120">
              </el-table-column>
              <el-table-column prop="receivingAddress" label="收货地址" width="260" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="revenueValuationName" label="收入计价" width="100" :formatter="formatterRowEmpty">
                <!-- <template scope="scope">
                  0.按吨、1.按车、2.按方、3.按件
                  <span v-show="scope.row.revenueValuation == '0'">按吨</span>
                  <span v-show="scope.row.revenueValuation == '1'">按车</span>
                  <span v-show="scope.row.revenueValuation == '2'">按方</span>
                  <span v-show="scope.row.revenueValuation == '3'">按件</span>
                </template> -->
              </el-table-column>
              <el-table-column prop="" label="收入单价" width="120">
                <template scope="scope">
                  <div>
                    <span v-if="scope.row.revenueValuation == '0'">{{scope.row.incomeUnitPrice}}元/吨</span>
                    <span v-if="scope.row.revenueValuation == '1'">
                      <span v-if="scope.row.incomeUnitPrice != 0">{{scope.row.incomeUnitPrice}}元/车</span>
                      <span v-else>-</span>
                    </span>
                    <span v-if="scope.row.revenueValuation == '2'">{{scope.row.incomeUnitPrice}}元/方</span>
                    <span v-if="scope.row.revenueValuation == '3'">{{scope.row.incomeUnitPrice}}元/件</span>
                    <span v-if="scope.row.revenueValuation == '' || scope.row.revenueValuation == null">-</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="incomeAmount" label="收入金额(元)" width="110">
              </el-table-column>
              <el-table-column prop="revenueSurcharge" label="附加费(元)" width="100">
              </el-table-column>
              <el-table-column prop="grossRevenue" label="收入总额(元)" width="110">
              </el-table-column>
              <el-table-column prop="plateNumber" label="车牌号" width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="driverName" label="司机姓名" width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="driverPhone" label="司机电话" width="120" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="ysInvoiceOn" label="发票号" width="200" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
              <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <div>
            <el-pagination background @current-change="handleCurrentChangeYSAdd" :current-page="YSAddFrom.pageNo" :page-size="YSAddFrom.pageSize"
              :page-sizes="[10,50,100,500,1000]" layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChangeYSAdd" :total="totalYSAdd"></el-pagination>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="saveFn">确定</el-button>
        </span>
      </el-dialog>
    </div>
     <!-- 申请开票 -->
    <shenqingkaipiao  v-if="SQkaiPiaoMark" :SQkaiPiaoMark.sync='SQkaiPiaoMark' :SQkaiPiaoFrom='kaiPiaoFrom' :detilsFlag = 'true'></shenqingkaipiao>
    <!-- 收款 -->
    <yiJianShouKuan v-if="shouKuanMark" :shouKuanMark.sync='shouKuanMark' :shouKuanFrom='shouKuanFrom' @refresh = 'getList' :detilsFlag = 'true'></yiJianShouKuan>
    <!-- 开票 -->
    <yiJianKaiPiao v-if="kaiPiaoMark" :kaiPiaoMark.sync='kaiPiaoMark' :kaiPiaoFrom='kaiPiaoFrom' @refresh = 'getList' :detilsFlag = 'true'></yiJianKaiPiao>
    <!-- 部分收款 -->
    <bufenShouKuan v-if="buFenSKMark" :buFenSKMark.sync='buFenSKMark' :buFenSKFrom='buFenSKFrom' @refresh = 'getList'></bufenShouKuan>
    <!-- 部分开票 -->
    <bufenKaiPiao v-if="buFenKPMark" :buFenKPMark.sync='buFenKPMark' :buFenKPFrom='buFenKPFrom' @refresh = 'getList' :shouKuanFlag = 'true'></bufenKaiPiao>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import { findWayBusinessList, addSettlementBillWayForYs, delSettlementBillWayForYs, invoiceApplyCheckForYsWayList,
  invoiceApplyForYsWayList } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty } from '@/utils/util'
import yiJianShouKuan from '@/views/newTMS/publicFiles/caiWuYingShou/yiJianShouKuan.vue'
import yiJianKaiPiao from '@/views/newTMS/publicFiles/caiWuYingShou/yiJianKaiPiao.vue'
import bufenShouKuan from '@/views/newTMS/publicFiles/caiWuYingShou/bufenShouKuan.vue'
import bufenKaiPiao from '@/views/newTMS/publicFiles/caiWuYingShou/bufenKaiPiao.vue'
import shenqingkaipiao from '@/views/newTMS/publicFiles/caiWuYingShou/shenqingkaipiao.vue'
export default {
  name: 'Freight',
  components: {
    yiJianShouKuan,
    yiJianKaiPiao,
    bufenShouKuan,
    bufenKaiPiao,
    shenqingkaipiao
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      YSAddMark: false,
      YSTitle: '添加应收',
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      formInline: {
        timeType: '1'
      },
      pagesize: 20,
      current: 1,
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00I0700', '01N00I0800', '01N00I0900', '01N00I0A00', '01N00I0B00', '01N00I0C00'],
      tableList: [],
      createTimes: [],
      actualSignings: [],
      YSAddFrom: {
        payeeType: '1',
        payee: this.$route.query.payee,
        settlementPattern: this.$route.query.settlementPattern,
        ysSettlementStates: '-1',
        makeTicketYn: this.$route.query.makeTicketYn,
        wayState: '4',
        // businessUnit: this.$route.query.businessUnit,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      totalYSAdd: 0,
      listYSData: [],
      duiZhangData: {
        wayNumber: 0, // 运单数量
        totalAmount: 0// 选中的应收总额
      },
      ids: [],
      shouKuanMark: false,
      shouKuanFrom: {
        pendingAmount: 0
      },
      kaiPiaoMark: false,
      kaiPiaoFrom: {
        invoiceAmount: 0
      },
      buFenSKMark: false,
      buFenSKFrom: {},
      buFenKPMark: false,
      buFenKPFrom: {},
      SQkaiPiaoMark: false,
      searchFrom: {},
      ysInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '待申请',
          value: '0'
        },
        {
          showName: '部分开票',
          value: '1'
        },
        {
          showName: '待开票',
          value: '11'
        },
        {
          showName: '已开票',
          value: '2'
        }
      ]
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yingShouSettlement')
    this.getList()
    // wayState 运单状态 0.待配载、1.待装车、2.运输中、3.待签收、4.已签收、5.已作废
    // 需要已签收条件时 传固定值'4'
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 130 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.wayNos) {
        let str = this.searchFrom.wayNos.trim().replace(/\n/g, ',')
        this.searchFrom.wayNoList = str.split(',')
      } else {
        this.$set(this.searchFrom, 'wayNos', '')
        this.searchFrom.wayNoList = null
      }
      this.searchFrom.ysSettlementBillId = this.$route.query.ysSettlementBillId
      findWayBusinessList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res
        // this.total = res.total
        // this.map = res.map
      })
    },
    chongZhi1 () {
      this.searchFrom = {
        ysSettlementBillId: this.$route.query.ysSettlementBillId
      }
      this.getList()
    },
    tableRowClassName ({ row }) {
      let rowName = ''
      const timestamp = new Date().getTime()
      if (row.periodDate < timestamp) {
        rowName = 'warning-row'
      } else {
        rowName = ''
      }
      return rowName
    },
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 选择数据
    selectGoods (selectData) {
      console.log(selectData, 'selectData')
      let totalAmount = 0
      let invoiceAmount = 0
      selectData.forEach((item, index) => {
        totalAmount += item.ysNoPaymentAmount
        invoiceAmount += item.ysNoInvoiceAmount
      })
      console.log(totalAmount, 'totalAmount')
      totalAmount = this.toFixed(totalAmount, 2)
      invoiceAmount = this.toFixed(invoiceAmount, 2)
      this.$set(this.shouKuanFrom, 'pendingAmount', totalAmount)
      this.$set(this.kaiPiaoFrom, 'invoiceAmount', invoiceAmount)
      // this.$set(this.shouKuanFrom,'wayNumber',selectData.length)
    },
    delFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        this.duiZhangData.totalAmount = 0
        selectData.forEach((item, index) => {
          this.duiZhangData.totalAmount += item.grossRevenue
          this.duiZhangData.wayNumber = index + 1
          this.ids.push(item.id)
        })
        this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
        this.$set(this.duiZhangData, 'ids', this.ids.toString())
        this.$set(this.duiZhangData, 'id', this.$route.query.ysSettlementBillId)
        console.log(this.duiZhangData, 'this.duiZhangData')
        this.$confirm('是否删除？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          delSettlementBillWayForYs(this.duiZhangData).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.getList()
          })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        }).catch(() => { })
      }
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.getList()
    },
    // 点击添加应收
    addYSFn () {
      this.YSAddMark = true
      this.listYSData = []
      this.getYSList()
    },
    handleCurrentChangeYSAdd (val) {
      this.YSAddFrom.pageNo = val
      this.getYSList()
    },
    handleSizeChangeYSAdd (val) {
      this.YSAddFrom.pageSize = val
      this.getYSList()
    },
    getYSList () {
      this.loading = true
      // this.YSAddFrom.createTimeStart = this.createTimes[0]
      // this.YSAddFrom.createTimeEnd = this.createTimes[1]
      this.YSAddFrom.actualSigningTimeStart = this.actualSignings[0]
      this.YSAddFrom.actualSigningTimeEnd = this.actualSignings[1]
      findWayBusinessList(this.YSAddFrom).then(res => {
        this.loading = false
        this.listYSData = res.list
        this.totalYSAdd = res.total
      })
    },
    // 查询
    chaxun () {
      this.getYSList()
    },
    chongZhi () {
      this.YSAddFrom = {
        payeeType: '1',
        payee: this.$route.query.payee,
        settlementPattern: this.$route.query.settlementPattern,
        ysSettlementStates: '-1',
        makeTicketYn: this.$route.query.makeTicketYn,
        // businessUnit: this.$route.query.businessUnit,
        wayState: '4',
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      // this.createTimes = []
      this.actualSignings = []
      this.getYSList()
    },
    saveFn () {
      let selectData = this.$refs.listYSData.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        this.duiZhangData.totalAmount = 0
        selectData.forEach((item, index) => {
          this.duiZhangData.totalAmount += item.grossRevenue
          this.duiZhangData.wayNumber = index + 1
          this.ids.push(item.id)
        })
        console.log(this.duiZhangData.totalAmount, 'this.duiZhangData.totalAmount')
        this.duiZhangData.totalAmount = this.toFixed(this.duiZhangData.totalAmount, 2)
        this.$set(this.duiZhangData, 'ids', this.ids.toString())
        this.$set(this.duiZhangData, 'id', this.$route.query.ysSettlementBillId)
        console.log(this.duiZhangData, 'this.duiZhangData')
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addSettlementBillWayForYs(this.duiZhangData).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.YSAddMark = false
          this.getList()
        })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }
    },
    // 点击关闭弹窗
    closeDialog () {
      this.YSAddMark = false
      this.YSAddFrom = {
        payeeType: '1',
        payee: this.$route.query.payee,
        settlementPattern: this.$route.query.settlementPattern,
        ysSettlementStates: '-1',
        makeTicketYn: this.$route.query.makeTicketYn,
        // businessUnit: this.$route.query.businessUnit,
        wayState: '4',
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      // this.createTimes = []
      this.actualSignings = []
    },
    // 点击收款
    shouKuanFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flagA = selectData.every(item => item.ysSettlementStates != '2')
        if (!flagA) {
          this.$alert('只能选择未收款或部分收款的数据', '系统提示')
          return
        }
        let shouKuanIds = []
        let totalAmount = 0
        selectData.forEach((item, index) => {
          totalAmount += item.ysNoPaymentAmount
          shouKuanIds.push(item.id)
        })
        console.log(totalAmount, 'totalAmount')
        totalAmount = this.toFixed(totalAmount, 2)
        this.$set(this.shouKuanFrom, 'ids', shouKuanIds.toString())
        this.$set(this.shouKuanFrom, 'settlementBillId', this.$route.query.ysSettlementBillId)
        this.$set(this.shouKuanFrom, 'recordType', 0)
        this.$set(this.shouKuanFrom, 'pendingAmount', totalAmount)
        this.$set(this.shouKuanFrom, 'collectionAmount', totalAmount)
        this.$set(this.shouKuanFrom, 'wayNumber', selectData.length)
        this.shouKuanMark = true
        // 参数 以下都必填
        // ids 运单业务表id逗号拼接
        // settlementBillId 账单表主键id
        // recordType 传固定值 0 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 收款金额（待收金额）
        // collectionAmount 收款金额（收款金额）
        // collectionTime 收款时间 日期类型
        // wayNumber 运单数量
      }
    },
    // 点击申请开票
    SQkaiPiaoFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flagB = selectData.every(item => item.ysInvoicingStates == '0')
        if (!flagB) {
          this.$alert('只能选择待申请的数据', '系统提示')
          return
        }
        let ids = selectData.map(item => item.id)
        this.kaiPiaoFrom.ids = ids.toString()
        this.kaiPiaoFrom.billId = this.$route.query.ysSettlementBillId
        this.SQkaiPiaoMark = true
      }
    },

    // 点击开票
    kaiPiaoFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flagB = selectData.every(item => item.ysInvoicingStates != '2')
        if (!flagB) {
          this.$alert('只能选择未开票或部分开票的数据', '系统提示')
          return
        }
        let kaiPiaoIds = []
        let invoiceAmount = 0
        selectData.forEach((item, index) => {
          invoiceAmount += item.ysNoInvoiceAmount
          kaiPiaoIds.push(item.id)
        })
        invoiceAmount = this.toFixed(invoiceAmount, 2)
        console.log(invoiceAmount, 'invoiceAmount')
        this.$set(this.kaiPiaoFrom, 'ids', kaiPiaoIds.toString())
        this.$set(this.kaiPiaoFrom, 'settlementBillId', this.$route.query.ysSettlementBillId)
        this.$set(this.kaiPiaoFrom, 'recordType', 0)
        this.$set(this.kaiPiaoFrom, 'wayNumber', selectData.length)
        this.$set(this.kaiPiaoFrom, 'invoiceAmount', invoiceAmount)
        this.$set(this.kaiPiaoFrom, 'pendingAmount', invoiceAmount)
        this.kaiPiaoMark = true
        // 参数 以下都必填
        // ids 运单业务表id逗号拼接
        // settlementBillId 账单表主键id
        // invoiceNo 发票号码
        // recordType 传固定值 0 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 开票金额（待开金额）
        // invoiceAmount 开票金额（开票金额）
        // invoiceTime 开票时间 日期类型
        // wayNumber 运单数量
      }
    },
    // 点击部分收款
    buFenSKFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].ysSettlementStates == '2') {
          this.$alert('只能选择未收款或部分收款的数据', '系统提示')
          return
        }
        this.$set(this.buFenSKFrom, 'wayBusinessId', selectData[0].id)
        this.$set(this.buFenSKFrom, 'settlementBillId', this.$route.query.ysSettlementBillId)
        this.$set(this.buFenSKFrom, 'recordType', 1)
        this.$set(this.buFenSKFrom, 'wayNumber', 1)
        this.$set(this.buFenSKFrom, 'pendingAmount', selectData[0].ysNoPaymentAmount)
        this.buFenSKMark = true
        // 参数 以下都必填
        // id 运单业务表id
        // settlementBillId 账单表主键id
        // recordType 传固定值1 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 待收金额
        // collectionAmount 收款金额
        // collectionTime 收款时间 日期类型
        // wayNumber 运单数量 1
      }
    },
    // 点击部分开票
    buFenKPFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].ysInvoicingStates == '2') {
          this.$alert('只能选择未开票或部分开票的数据', '系统提示')
          return
        }
        this.$set(this.buFenKPFrom, 'wayBusinessId', selectData[0].id)
        this.$set(this.buFenKPFrom, 'settlementBillId', this.$route.query.ysSettlementBillId)
        this.$set(this.buFenKPFrom, 'recordType', 1)
        this.$set(this.buFenKPFrom, 'wayNumber', 1)
        this.$set(this.buFenKPFrom, 'pendingAmount', selectData[0].ysNoInvoiceAmount)
        this.buFenKPMark = true
        // 参数 以下都必填
        // id 运单业务表id
        // settlementBillId 账单表主键id
        // invoiceNo 发票号码
        // recordType 传固定值 1 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 待开金额
        // invoiceAmount 开票金额
        // invoiceTime 开票时间 日期类型
        // wayNumber 运单数量 1
      }
    },
    back () {
      // this.$router.go(-1)// 返回上一层
      this.$router.push({ name: 'yingShouSettlement', query: { ZDFlag: true } })
    }
  }
}
</script>
<style lang="scss">
.el-form-item {
  margin-left: 10px;
}
.el-table__body tr.warning-row > td {
  background-color: #f9bc04 !important;
}
/deep/.el-range-editor--mini.el-input__inner {
  height: 28px;
  width: 315px !important;
}
/deep/.inpBox .el-input--mini .el-input__inner{
  width: 150px !important;
}
.detailsTitle{
  margin-bottom:0px;
}
</style>
